import React, { useCallback, useEffect, useState } from 'react';
import { Modal, Checkbox, Input, Icon, Button, message } from 'antd';
import request from '../../../../../../base/request';
import './changeCollectFolder.css';

const ChangeCollectFolder = ({ visible, cancel, refreshData, saveArticle, cancelCollect }) => {
  const [data, setData] = useState([])
  const [isFocus, setIsFocus] = useState(false);
  const [folderName, setFolderName] = useState('');
  const [checkedFolderId, setCheckedFolderId] = useState([]);

  useEffect(() => {
    if (visible) {
      getCollectFolder();
    }
  }, [visible]);

  useEffect(() => {
    if (data && data.length) {
      const defaultId = data.length && data.find(item => item.stats === 0).id;
      setCheckedFolderId([defaultId]);
    }
  }, [data]);

  const getCollectFolder = useCallback(() => {
    refreshData().then((data) => {
      setData(data);
    }).catch(() => {
      setData([]);
      message.destroy();
      message.warning('获取收藏夹失败');
    });
  }, []);

  const createFolder = useCallback(() => {
    const filterArray = data.filter((item) => {
      return item.name === folderName;
    })
    if (filterArray.length) {
      message.destroy();
      message.warning('收藏夹名称重复');
    } else {
      request({
        url: '/cm-sites-media-consumer/collect/saveCollectType',
        method: 'post',
        contentType: 'json',
        body: {
          name: folderName
        },
        callBack: () => {
          message.destroy();
          message.success('新建成功');
          getCollectFolder();
          setFolderName('');
        }
      });
    }
  }, [folderName, data]);

  const submitHandler = useCallback(() => {
    if (checkedFolderId.length) {
      saveArticle({
        collectTypeIds: checkedFolderId, callBack: () => {
          message.destroy();
          message.success('收藏成功');
          cancel();
        }
      });
    } else {
      cancelCollect();
      cancel();
    }
  }, [checkedFolderId]);
  return (
    <Modal
      className="folderModalStyle"
      title="修改收藏位置"
      width={400}
      centered
      visible={visible}
      onCancel={cancel}
      footer={[
        <Button key="back" type='primary' onClick={submitHandler}>完成</Button>,
        // <Button key="submit" onClick={() => {
        //   cancelCollect();
        //   cancel();
        // }}>移除</Button>
      ]}
    >
      {data && data.map((item) => {
        return (
          <div className='folderItemStyle' key={item.id}>
            <div>
              <Checkbox checked={checkedFolderId.includes(item.id)} onChange={(e) => {
                if (e.target.checked) {
                  setCheckedFolderId((prev) => {
                    return [...prev, item.id]
                  })
                } else {
                  setCheckedFolderId(checkedFolderId.filter(id => id !== item.id))
                }
              }}></Checkbox>
            </div>
            <div id="folderItemName">
              {item.name}
            </div>
            <div>{item.articleNum}</div>
          </div>
        )
      })}
      <div className={`folderCreate ${isFocus ? 'focus' : ''}`}>
        <Input placeholder={isFocus ? '最多可输入20个字' : '新建收藏夹'}
          style={{
            width: isFocus ? '285px' : '100%'
          }}
          onFocus={() => {
            setIsFocus(true);
          }}
          onBlur={() => {
            setIsFocus(false);
          }}
          value={folderName}
          onChange={(e) => {
            setFolderName(e.target.value);
          }}
          maxLength={20}
          prefix={<Icon type='plus'></Icon>} />
        {(isFocus || folderName) && <Button type='default' onClick={createFolder}>新建</Button>}
      </div>
    </Modal>
  )
}

export default ChangeCollectFolder;